import React from 'react';

const GlobalNoScroll = () => <style children={`:root{overflow:hidden}`} />;

export default GlobalNoScroll;